var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteForeverBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1375_1639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1375_1639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 17.5C5.37516 17.5 4.9828 17.3368 4.65641 17.0104C4.33002 16.684 4.16683 16.2917 4.16683 15.8333V5C3.93072 5 3.7328 4.92014 3.57308 4.76042C3.41336 4.60069 3.3335 4.40278 3.3335 4.16667C3.3335 3.93056 3.41336 3.73264 3.57308 3.57292C3.7328 3.41319 3.93072 3.33333 4.16683 3.33333H7.50016C7.50016 3.09722 7.58002 2.89931 7.73975 2.73958C7.89947 2.57986 8.09738 2.5 8.3335 2.5H11.6668C11.9029 2.5 12.1009 2.57986 12.2606 2.73958C12.4203 2.89931 12.5002 3.09722 12.5002 3.33333H15.8335C16.0696 3.33333 16.2675 3.41319 16.4272 3.57292C16.587 3.73264 16.6668 3.93056 16.6668 4.16667C16.6668 4.40278 16.587 4.60069 16.4272 4.76042C16.2675 4.92014 16.0696 5 15.8335 5V15.8333C15.8335 16.2917 15.6703 16.684 15.3439 17.0104C15.0175 17.3368 14.6252 17.5 14.1668 17.5H5.8335ZM10.0002 11.5833L11.5835 13.1667C11.7363 13.3194 11.9307 13.3958 12.1668 13.3958C12.4029 13.3958 12.5974 13.3194 12.7502 13.1667C12.9029 13.0139 12.9793 12.8194 12.9793 12.5833C12.9793 12.3472 12.9029 12.1528 12.7502 12L11.1668 10.4167L12.7502 8.83333C12.9029 8.68056 12.9793 8.48611 12.9793 8.25C12.9793 8.01389 12.9029 7.81944 12.7502 7.66667C12.5974 7.51389 12.4029 7.4375 12.1668 7.4375C11.9307 7.4375 11.7363 7.51389 11.5835 7.66667L10.0002 9.25L8.41683 7.66667C8.26405 7.51389 8.06961 7.4375 7.8335 7.4375C7.59738 7.4375 7.40294 7.51389 7.25016 7.66667C7.09739 7.81944 7.021 8.01389 7.021 8.25C7.021 8.48611 7.09739 8.68056 7.25016 8.83333L8.8335 10.4167L7.25016 12C7.09739 12.1528 7.021 12.3472 7.021 12.5833C7.021 12.8194 7.09739 13.0139 7.25016 13.1667C7.40294 13.3194 7.59738 13.3958 7.8335 13.3958C8.06961 13.3958 8.26405 13.3194 8.41683 13.1667L10.0002 11.5833Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteForeverBlue);
export default __webpack_public_path__ + "static/media/icon_delete_forever_blue.c09ff823371da2fdea67cf8d0b17ead9.svg";
export { ForwardRef as ReactComponent };